import * as React from 'react';
import FullWidthContainer from 'components/FullWidthContainer';
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import VideoModal from 'components/VideoModal';
import Grid from '@mui/material/Grid2';
import Image from 'components/Image';
import zparse from '../zparse';

import playButton from 'images/play-button.svg';


// import theme, { getColor } from "utils/theme";
// import styled from '@mui/system/styled';


const TwoColumnVideo = ({orientation, flush, background, backgroundImage, backgroundProps, padding, videoLoop, thumbnail, video, title, body}) => {
	const [open, setOpen] = React.useState(false);
	const previewVideoRef = React.useRef(null);

	const resetPreview = () => {
		if (previewVideoRef.current) {
			previewVideoRef.current.pause();
			previewVideoRef.current.currentTime = 0;
			if (thumbnail)previewVideoRef.current.load();
		}
	}

	const playPreview = () => {
		if (!open && previewVideoRef.current) {
			previewVideoRef.current.play();
		}
	}

	const pausePreview = () => {
		if (!open && previewVideoRef.current)resetPreview();
	}

	const playVideo = (evt) => {
		evt.stopPropagation();
		resetPreview();
		setOpen(true);
	}

	const closeVideo = (evt) => {
		evt.stopPropagation();
		resetPreview();
		setOpen(false);
	}

	let videoSrc = '';
	const frameSrcRe = /<iframe(?:[^>+])src=(?:"|')(?<src>[^"|']+)(?:"|')/i;
	const result = frameSrcRe.exec(video);
	if (result !== null)videoSrc = result.groups.src;

	const inlineStyle = {
		...(backgroundImage ? {
			backgroundImage: `url(${process.env.CDN_DOMAIN||''}${backgroundImage})`,
			...(backgroundProps ? {
				...(backgroundProps.indexOf('cover') !== -1 ? {
					backgroundSize: 'cover',
				} : null),
				...(backgroundProps.indexOf('fixed') !== -1 ? {
					backgroundAttachment: 'fixed',
				} : null),
				...(backgroundProps.indexOf('repeat') !== -1 ? {
					backgroundRepeat: 'repeat',
				} : {backgroundRepeat: 'no-repeat'}),
			} : null),
		} : null),
	}

	return (
		<FullWidthContainer sx={(Object.keys(inlineStyle).length > 0 ? inlineStyle : null)} className={`SmartTag-root TwoColumnVideo-root ${background||''} ${padding ? 'padding-normal' : ''} ${flush ? 'margin-flush' : ''}`}>
			<Container>
				<Grid container>
					<Grid size={{ xs: 12, sm: 5 }}>
						<FullWidthContainer className="TwoColumnVideo-thumbnailContainer" onClick={playVideo} onMouseEnter={(videoLoop ? playPreview : null)} onMouseLeave={(videoLoop ? pausePreview : null)}>
							{ !!videoLoop === false &&
								<>
								<Image src={thumbnail} width="100%" height="100%" />
								<Box className="TwoColumnVideo-buttonContainer">
									<Button variant="silent" onClick={playVideo}><img src={playButton} alt="Play Video"/></Button>
								</Box>
								</>
							}
							{ !!videoLoop &&
								<Box className="TwoColumnVideo-videoLoop">
									<video ref={previewVideoRef} muted loop playsinline poster={thumbnail}>
										<source src={`${process.env.CDN_DOMAIN||''}${videoLoop}`} type="video/mp4" />
									</video>
									<Box className="TwoColumnVideo-buttonContainer">
										<Button variant="silent" onClick={playVideo}><img src={playButton} alt="Play Video"/></Button>
									</Box>
								</Box>
							}
						</FullWidthContainer>
					</Grid>
					<Grid offset="auto" size={{ xs: 12, sm: 6 }}>
						<Typography variant="h2" className="TwoColumnVideo-title" component="h2">{title}</Typography>
						<Box className="TwoColumnVideo-body">
							{zparse(body)}
						</Box>
					</Grid>
				</Grid>
			</Container>
			<VideoModal open={open} onClose={closeVideo} alt="video player" src={videoSrc} />
		</FullWidthContainer>
	)
}

export default TwoColumnVideo;